import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { useRef, useState } from "react";
import { Add, Cancel } from "@mui/icons-material";

function toDict<T>(array: T[], startIndex: number = 1): { [idx: number]: T } {
  const init: { [idx: number]: T } = {};
  let idx = startIndex;
  return array.reduce((prev, curr) => {
    prev[idx] = curr;
    idx += 1;
    return prev;
  }, init);
}

export function MultiItemSelection({
  title,
  selectedItems,
  availableSelections,
  onChange,
}: {
  title: string;
  selectedItems: string[];
  availableSelections: string[];
  onChange: (columns: { [index: number]: string }) => void;
}) {
  const [showSelector, setShowSelector] = useState(false);
  const anchorEl = useRef(null);
  const handleMenuOpen = (event: any) => {
    setShowSelector(true);
  };

  const handleMenuClose = () => {
    setShowSelector(false);
  };

  const removeColumnAt = (index: number) => {
    delete selectedItems[index];
    const newColumnMapping = toDict(selectedItems);
    onChange(newColumnMapping);
  };
  const addColumn = (columnKey: string) => {
    selectedItems.push(columnKey);
    onChange(toDict(selectedItems));
  };

  const addColumnOptions = availableSelections.map((item) => {
    return (
      <MenuItem
        key={item}
        onClick={() => {
          addColumn(item);
          handleMenuClose();
        }}
      >
        <ListItemText>{item}</ListItemText>
      </MenuItem>
    );
  });
  return (
    <List>
      {title}
      {availableSelections.length > 0 ? (
        <Add onClick={handleMenuOpen} ref={anchorEl} />
      ) : (
        <></>
      )}
      {selectedItems.map((item, index) => {
        return (
          <ListItem key={item + index}>
            <ListItemText>{item}</ListItemText>
            <ListItemIcon onClick={() => removeColumnAt(Number(index))}>
              <Cancel />
            </ListItemIcon>
          </ListItem>
        );
      })}
      <Menu
        open={showSelector}
        onClose={handleMenuClose}
        onChange={handleMenuClose}
        anchorEl={anchorEl.current}
      >
        {addColumnOptions}
      </Menu>
    </List>
  );
}
